import store from '@/state/store';
import { deleteLogo } from '@/api/project';
import projectSlice from '@/state/project.slice';
import { handleError } from '@/actions/common';

export default async (projectId: string) => {
  try {
    store.dispatch(projectSlice.actions.logoBusy(projectId));
    await deleteLogo(projectId);
    store.dispatch(projectSlice.actions.logoIdle({
      projectId,
      source: null
    }));
  } catch (error) {
    store.dispatch(projectSlice.actions.logoError(projectId));
    handleError(error);
  }
};